class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide(this.amount);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/dialog/dialog.controller.js